module.exports = __webpack_public_path__ + "img/W-22.54d5adeb.jpg";